export default __webpack_public_path__ + "static/media/main-logo--light.29e1aa04.svg";